import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/Layouts/Navbar";
import HomePage from "./pages/HomePage";
import PublicHomePage from "./pages/PublicHomePage";
import CreatePost from "./pages/CreatePost";
import ViewPosts from "./pages/ViewPosts";
import SignInUser from "./pages/LoginUser";
import PostView from "./components/PostCard/PostView";
import Logout from "./pages/LogoutUser";
import { useDispatch } from "react-redux";
import { loadUser } from "./Actions/user";
import { useSelector } from "react-redux";
import Resources from "./pages/Resources";
import VerifyEmail from "./pages/VerifyEmail";
import JobPosting from "./pages/JobPosting";
import CreateJob from "./pages/CreateJob";
import UploadResources from "./pages/UploadResource";
import ResetLink from "./pages/ResetLink";
import UserProfile from "./pages/UserProfile";
import EditProfile from "./pages/EditProfile";
import AnnouncementCard from "./components/AnnouncementCard/AnnouncementCard";
import HelpPage from "./pages/helpPage";
import AdminFeedback from "./pages/AdminFeedback";
import QAPage from "./pages/QAPage";
import DevConstants from "./pages/DevConstants";
import { ROUTES } from "./constants";
import OnboardingFlow from "./pages/OnboardingFlow";
import CampusIRALoader from "./pages/CampusIRALoader";

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.user);
  const { user } = useSelector((state) => state.user) || {}; // Ensure user is defined
  const isAdmin = useSelector((state) => state.user?.user?.role) === "admin";

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  const { loading } = useSelector((state) => state.user);

  if(loading ) {
    return <CampusIRALoader/>
  }

  if (isAuthenticated && !user?.onboardingCompleted) {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<OnboardingFlow />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <div className="sticky top-0 bg-white z-20">
        {isAuthenticated ? <Navbar user={user} /> : <Navbar user={null} />}
      </div>

      { isAuthenticated && <AnnouncementCard/> }

      <Routes>
        <Route
          path={ROUTES.home}
          element={isAuthenticated ? <HomePage /> : <PublicHomePage />}
        />
        <Route
          path={ROUTES.createPost}
          element={<CreatePost />}
        />

        <Route path={ROUTES.posts} element={<ViewPosts />} />
        <Route
          path={ROUTES.createJob}
          element={!isAuthenticated ? <Navigate to={ROUTES.login} /> : <CreateJob />}
        />
        <Route path={ROUTES.uploadResources} element={<UploadResources />} />
        <Route path={ROUTES.jobs} element={<JobPosting />} />
        {/* <Route path="/register" element={<RegisterUser />} /> */}
        <Route path={ROUTES.verifyEmail} element={<VerifyEmail />} />
        <Route path={ROUTES.resetLink} element={<ResetLink />} />
        <Route
          path={ROUTES.login}
          element={isAuthenticated ? <Navigate to={ROUTES.home} /> : <SignInUser />}
        />

        <Route
          path={ROUTES.postDetail(":postId")}
          element={<PostView />}
        />

        <Route
          path={ROUTES.editProfile}
          element={isAuthenticated ? <EditProfile /> : <HomePage />}
        />

        <Route
          path={ROUTES.onboarding}
          element={<OnboardingFlow />}
        />

        <Route path={ROUTES.logout} element={<Logout />} />
        <Route path={ROUTES.userProfile(":userId")} element={<UserProfile />} />
        <Route path={ROUTES.resources} element={<Resources />} />
        <Route
          path={ROUTES.editPost(":postId")}
          element={<CreatePost EditPost={true} />}
        />
        <Route path={ROUTES.help} element={<HelpPage />} />
        <Route
          path={ROUTES.adminFeedback}
          element={isAdmin ? <AdminFeedback /> : <Navigate to={ROUTES.login} />}
        />
        {/* Add more routes as needed */}
        <Route path={ROUTES.qaPage} element={<QAPage />} />
        {process.env.NODE_ENV !== "production" && (
          <Route path={ROUTES.devConstants} element={<DevConstants />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;
